import { Account } from '@orbis-systems/orbis-api-middleware';
import { createAction } from '@reduxjs/toolkit';

export const setCurrentClientAccount = createAction<Account | null>('SetCurrentClientAccount');
